import React from 'react';
import { Helmet } from 'react-helmet';
import { Search } from '../../components/test/test'; // Adjust the import path as necessary

export const Dev = () => {
    return (
        <div>
            <Helmet>
                <title>Dev Page | VoteSee</title>
                <meta name="description" content="Development and testing page for VoteSee components." />
                <meta name="robots" content="noindex, nofollow" /> {/* Discourage indexing */}
                <meta property="og:title" content="Dev Page | VoteSee" />
                <meta property="og:description" content="Development and testing page for VoteSee components." />
                <meta property="og:url" content="https://www.votesee.com/dev" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://www.votesee.com/images/previews/find-rep-preview.png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Dev Page | VoteSee" />
                <meta name="twitter:description" content="Development and testing page for VoteSee components." />
                <meta name="twitter:image" content="https://www.votesee.com/images/previews/find-rep-preview.png" />
            </Helmet>
            <Search />
        </div>
    );
};

export default Dev;